import React from 'react'
import VenueWiseReport from './VenueWiseReport'

export default function NewDashboard() {
    return (
        <>
            <VenueWiseReport showAttendanceOverview={false} />
        </>
    )
}